export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  // {
  //   field: 'col-opt',
  //   title: that.$l('INDEX.table_label_operation') || '操作',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 140,
  //   slots: {
  //     default: 'opt'
  //   }
  // },


  {
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent'
    },
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_orderGoodsSpecNo') || '规格编号',
    field: 'orderGoodsSpecNo',
    minWidth: 150,
    align: 'center'
  },
  {
    title: that.$l('INDEX.order_spec_label_identifyGoodsSpecNo') || '规格识别编号',
    field: 'identifyGoodsSpecNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_spec_label_identifyGoodsName') || '识别名称',
    field: 'identifyGoodsName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_total_planned') || '计划总数',
    field: 'planQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_total_scheduled_production') || '已排产总数',
    field: 'schedulingQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_total_completed') || '已完成总数',
    field: 'finishQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    field: 'modifyByName',
    align: 'center',
    minWidth: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true
  },
  {
    field: 'modifyDate',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true
  }
]
